<template>
    <div v-if="model" class="ml-3 mr-3">
        <h5 class="text-center mb-4">GENERAL</h5>
        <div class="form-row mb-2">
            <label class="col-5">Last four digits of Social Security Number</label>
            <div class="input-group col">
                <input type="text" class="form-control" placeholder="Last four digits of Social Security Number" v-model="model.ssn" />
            </div>
        </div>
        <div class="form-row mb-2">
            <label class="col-5">Date of Injury or Illness</label>
            <div class="input-group col">
                <input type="date" class="form-control" placeholder="Date of Injury or Illness" v-model="model.injuryDate" />
                <div class="input-group-append">
                    <span class="input-group-text fas fa-calendar pt-2"></span>
                </div>                               
            </div>
        </div>
        <div class="form-row mb-2">     
            <label class="col-5">Parts of Body Injured</label>
            <div class="input-group col">
                <input type="text" class="form-control col" placeholder="Parts of Body Injured" v-model="model.injury" />
            </div>
        </div>
        <div class="form-row mb-2">
            <label class="col-5">Date of Birth</label>
            <div class="input-group col">
                <input type="date" class="form-control" placeholder="Date of Birth" v-model="model.dob" />
                <div class="input-group-append">
                    <span class="input-group-text fas fa-calendar pt-2"></span>
                </div>                               
            </div>
        </div>
        <div class="form-row">
            <label class="col-5">Claim Number</label>
            <div class="input-group col">
                <input type="text" class="form-control col" placeholder="Claim Number" v-model="model.claimNumber" />
            </div>
        </div>     
    </div>
</template>

<script>
export default {
    props: {
        model: Object,
    },
}
</script>

<style>

</style>


